import { createSlice } from '@reduxjs/toolkit';

import treeTradeInitialState from './initialState';
import reducers from './reducers';

const treeTradeSlice = createSlice({
  name: '@treetrade',
  initialState: treeTradeInitialState,
  reducers,
});

export const treeTradeActions = treeTradeSlice.actions;
export const treeTradeReducers = treeTradeSlice.reducer;
